import React from 'react';
import { formatNumber } from '../../utils/format';
import { useP } from '../../i18n/useP';
import './HrPage.css';

/* Graphique de variation des salaires bruts, onglet « Planning des effectifs ».

   Il y était, il est parti en « Masse salariale planifiée » le 2026-08-22, il
   est revenu le 2026-08-26. Ce qui a changé entre les deux : la PLACE. Il
   partageait une ligne avec les tuiles de synthèse et n'avait plus que la
   moitié de la largeur, au point d'écraser la frise sur une entreprise de
   trente personnes. Il occupe désormais la deuxième card, pleine largeur.

   Règle qui ne bouge pas : les deux séries doivent sortir DU MÊME CALCUL. Un
   graphique qui compare deux moteurs ne compare rien. Ici, ce sont les séries
   mensuelles de l'écran (contrats seuls / mouvements compris), les mêmes qui
   nourrissent les tuiles juste au-dessus. */
export default function PayrollVariationChart({
  gross, base, monthLabels, year, sepIdx = -1, onAddHire, onAddCut, canPlan = false,
  aside = null, collapsed = false,
}) {
  const p = useP();
  const max = Math.max(1, ...gross, ...base);

  return (
    <div className={`hr-chart hr-chart--wide${collapsed ? ' hr-chart--collapsed' : ''}`}>
      {/* Le bouton de repli précède le titre (2026-08-30) : il AGIT sur ce qui
          suit, comme un chevron de groupe. À l'autre bout de la ligne, on ne
          voyait pas ce qu'il commandait. */}
      <div className="hr-chart__title" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {aside}
        <span>
          {p('VARIATION DES SALAIRES BRUTS')} · {year}
          <span style={{ marginLeft: 12, color: 'var(--color-text-muted)', fontSize: 10, textTransform: 'none', letterSpacing: 0 }}>
            {p('effectif (contrats + mouvements)')}
          </span>
        </span>
      </div>
      {/* Replié, il ne reste que le titre : la ligne du dessous se lit d'un
          coup quand on ne travaille pas les montants. */}
      {!collapsed && <div className="hr-chart__bars" style={{ gridTemplateColumns: 'repeat(12, 1fr)', gap: 6 }}>
        {gross.map((v, i) => {
          const h = Math.max(2, (v / max) * 100);
          const delta = v - (base[i] || 0);
          // Badge en milliers : masqué si l'écart arrondi au k est nul (sinon le
          // bruit d'arrondi des extras affiche « -0k »).
          const showDelta = Math.round(delta / 1000) !== 0;
          return (
            <div className="hr-chart__col" key={i}>
              <div className="hr-chart__val">
                {formatNumber(v / 1000, 0)}k
                {showDelta && (
                  <span className={`hr-chart__val-delta ${delta > 0 ? 'is-up' : 'is-down'}`}>
                    {delta > 0 ? '+' : ''}{formatNumber(delta / 1000, 0)}k
                  </span>
                )}
              </div>
              <div className="hr-chart__bar-wrap">
                <div
                  className="hr-chart__bar"
                  style={{ height: `${h}%`, background: 'var(--color-accent)' }}
                  title={`${monthLabels[i]} ${year} — ${formatNumber(v, 0)} CHF${showDelta ? ` (${delta > 0 ? '+' : ''}${formatNumber(delta, 0)} ${p('vs contrats')})` : ''}`}
                />
                {canPlan && i >= sepIdx && sepIdx >= 0 && (
                  <div className="hr-chart__add hr-page__no-print">
                    <button type="button" className="hr-chart__add-btn hr-chart__add-btn--hire"
                      onClick={() => onAddHire && onAddHire(i)} title={p('Ajouter un poste sur ce mois')}>+</button>
                    <button type="button" className="hr-chart__add-btn hr-chart__add-btn--cut"
                      onClick={() => onAddCut && onAddCut(i)} title={p('Réduction générale sur ce mois')}>−</button>
                  </div>
                )}
              </div>
              <div className="hr-chart__month">{monthLabels[i]}</div>
            </div>
          );
        })}
      </div>}
    </div>
  );
}
